import { Typography } from "@mui/material";
import React from "react";

function TotalChart({ total ,size}) {
  return (
    <>
      {total?.map((item) => {
        return (
          <Typography 
          fontSize={size?size:14}
            sx={{
              width: {md: "15%", xs: "40%"},
              padding:{md: "0", xs: "0.5rem 0"}
            }} 
            key={item?.key || 'default-key'} 
            margin={{md: "0 1rem", xs: "0 0.5rem"}} 
            color={item?.color || 'inherit'}
            textAlign={"start"}
          >
            {" "}
            {item.title} {item.count?":" +item.count:""}
          </Typography>
        );
      })}
    </>
  );
}

export default TotalChart;
